import classNames from 'classnames';
import React from 'react';
import styles from './LoggedOut.module.scss';
import { SimpleAppBar } from './SimpleAppBar';

export class LoggedOut extends React.Component {
    public render() {
        return (
            <div id='main'>
                <div className={styles.container}>
                    <SimpleAppBar />
                    <div className={styles.containerBody}>
                        <h1 className={styles.logoutHeading}>Logged Out</h1>
                        <h3 className={styles.logoutSubheading}>You are now logged out of Communicare.</h3>
                        <p>If the application is automatically logging out, contact our support team.</p>
                        <p>
                            <a href='/login' className={classNames(styles.button, styles.link, styles.default)}>
                                Return to Application
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        );
    }
}
